<template>
  <div>
    <Modal
      class="layerModel"
      width="902"
      v-model="currentMenuStatus"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
    >
    <!-- 上面提示文字 -->
    <div class="tip-header">
      <span v-if="titleLayer === 1">菜单新建</span>
      <span v-if="titleLayer === 2">菜单编辑</span>
      <span v-if="titleLayer === 3">菜单复制</span>
      <span class="iconfont ys-iconguanbi" @click="handleReset('formValidate')"></span>
    </div>
    <!-- 菜单名称 -->
    <div class="meanTitle" v-if="titleLayer === 1">
      <span>上级菜单名称</span>&nbsp;&nbsp;
      <span>{{ addObj.con_name }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
      <span>当前菜单级别</span>&nbsp;&nbsp;
      <span>{{ addObj.rs_level }}</span>
    </div>
    <div class="meanTitle" v-if="titleLayer === 2 || titleLayer === 3">
      <span>上级菜单名称</span>&nbsp;&nbsp;
      <span>{{ editObj.fs_cn_name }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
      <span>当前菜单级别</span>&nbsp;&nbsp;
      <span>{{ editObj.rs_level }}</span>
    </div>
    <!-- form表单 -->
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
      <div class="userBox">
        <FormItem prop="rs_cn_name" style="margin-right: 18px;width: 100%;">
          <Input class="ys_input_border_bottom" v-model="formValidate.rs_cn_name" placeholder="请输入菜单名称" />
        </FormItem>
        <FormItem style="width: 100%;">
          <Input class="ys_input_border_bottom" v-model="formValidate.rs_url" placeholder="请输入菜单路由器地址" />
        </FormItem>
      </div>
      <div class="userBox">
        <FormItem style="margin-right: 18px;width: 100%;">
          <Input class="ys_input_border_bottom" v-model="formValidate.rsim_url" placeholder="请输入菜单图标名称" />
        </FormItem>
        <FormItem style="width: 100%;">
           <InputNumber style="width: 100%;" :max="99999999999" :min="1" v-model="formValidate.sort_key" placeholder="请选择排序"></InputNumber>
        </FormItem>
      </div>
      <FormItem>
        <Input type="textarea" style="width: 100%;" v-model="formValidate.rs_bk_desc" placeholder="请输入备注信息" :autosize="{minRows: 5,maxRows: 8}" />
      </FormItem>
    </Form>
    <!-- 按钮组 -->
    <div class="btn-box">
      <Button  class="ys-cancel" @click="handleReset('formValidate')" style="width: 100px; margin-right: 20px">取消</Button>
      <Button class="ys-confirm" type="primary" @click="handleSubmit('formValidate')" style="width: 100px;">确认</Button>
    </div>
  </Modal>
  </div>
</template>
<script>
import { 
  mapActions
} from "vuex";
export default {
  props: {
    currentMenuStatus:{
      type: Boolean,
      defalut: false
    },
    currentIndex: {
      type: Number,
      defalut: 1
    },
    titleLayer: {
      type: Number,
      default: 1
    },
    addObj: {
      type: Object,
      default: {}
    },
    editObj: {
      type: Object,
      default: {}
    }
  },
  watch: {
    currentIndex: {
      immediate:true,
      handler(newValue, oldValue) {
        switch (this.titleLayer) {
          case 1: // 新建
            break;
          case 2: // 編輯
            // 編輯回顯
            this.handleEcho();
            break;
          case 3: // 複製
            // 複製回顯
            this.haddleCopy();
            break;
          default:
            break;
        }
      }
    }
  },
  data() {
    return {
      test: true,
      titleTable: '', // 表头title
      formValidate: {
        rs_cn_name: '', // 菜单名称
        rs_url: '', // IP地址
        rsim_url: '', // 图标
        sort_key: 1, // 排序
        rs_bk_desc: '', // 备注信息
      },
      ruleValidate: {
        rs_cn_name: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        sort_key: [
          { required: true, message: '请选择排序', trigger: 'change', type: Number }
        ]
      },
    }
  },
  methods: {
    ...mapActions([
      'addResource', // 新建保存
      'updateResource', // 编辑保存
    ]),
    // 确认
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          switch(this.titleLayer) {
            case 1: // 提交新建
              this.addResources(1);
              break;
            case 2: // 提交編輯
              this.updateResources();
              break;
            case 3: // 提交複製
              this.addResources(2);
              break;
            default:
              break;
          }
        } else {
          this.$Message.error('请完善信息！');
        }
      })
    },
    // 取消
    handleReset(name) {
      this.$refs[name].resetFields();
      this.$emit('on-jurisdiction-click', 2);
    },
    // 編輯回顯處理
    handleEcho() {
      this.formValidate = this.editObj;
    },
    // 複製回顯
    haddleCopy() {
      this.formValidate = this.editObj;
    },
    // 新建保存
    async addResources(code) {
      try {
        this.formValidate['open_type'] = 1;
        this.formValidate['public_yn_flag'] = 2;
        this.formValidate['title_able'] = 2;
        this.formValidate['rs_fun_type'] = 9;

        if (code === 1) {
          // 新建
          this.formValidate['rs_level'] = this.addObj.rs_level; // 
          this.formValidate['super_rs_code'] = this.addObj.super_rs_code;
          this.formValidate['bl_rs_code'] = this.addObj.rs_code;
        } else {
          // 复制
          this.formValidate['rs_level'] = this.editObj.rs_level; // 
          this.formValidate['super_rs_code'] = this.editObj.super_rs_code;
          this.formValidate['bl_rs_code'] = this.editObj.bl_rs_code;
          delete this.formValidate.rs_code;
          delete this.formValidate.children;
        }
        const data = await this.addResource({info: this.formValidate});
        if (data.request_state) {
          this.$Message.success( code === 1 ? '新建成功' : '複製成功');
          this.$emit('on-jurisdiction-click', 1);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 编辑保存
    async updateResources() {
      try {
        this.formValidate['bl_rs_code'] = this.editObj.bl_rs_code;
        const data = await this.updateResource(this.formValidate);
        if (data.request_state) {
          this.$Message.success('编辑成功！');
          this.$emit('on-jurisdiction-click', 1);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>
<style lang="less" scoped>
.layerModel {
  .tip-header {
    width: 100%;
    height: 30px;
    line-height: 30px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-bottom: 22px;
    span:nth-of-type(1) {
      font-size:18px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(179,195,226,1);
    }
    span:nth-of-type(2) {
      font-size: 28px;
    }
    span:nth-of-type(2):hover {
      cursor: pointer;
    }
  }
  .meanTitle {
    width: 100%;
    margin-bottom: 34px;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    span:nth-of-type(1),
    span::nth-of-type(3) {
      color:rgba(80,103,134,1);
    }
    span:nth-of-type(2),
    span::nth-of-type(4) {
      color:rgba(128,146,176,1);
    }
  }
  .userBox {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
  }
  .btn-box {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    margin-top: 40px;
  }
}
</style>
